import { render, staticRenderFns } from "./LoginJournal.vue?vue&type=template&id=5af91590&scoped=true&"
import script from "./LoginJournal.vue?vue&type=script&lang=js&"
export * from "./LoginJournal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af91590",
  null
  
)

export default component.exports